import React from 'react'
import { connect } from 'react-redux'
import { Modal, ModalBody } from 'reactstrap'
import Close from '../../../common/ui/Close'
import OrientationList from '../../orientations/OrientationsList'
import styled from 'styled-components'
import { updateWorkerProspectOrientation } from '../../../../actions/prospects';

const OrientationModal = styled(Modal)`
  max-width: 80vw !important;
  width: 80vw !important;
`

const SelectOrientationModal = ({ isOpen, closeModal, prospect, updateWorkerProspectOrientation }) => {
  const updateOrientation = (orientationId) => {
    updateWorkerProspectOrientation(prospect.id, orientationId)
      .then(closeModal)
  }

  return (
    <OrientationModal isOpen={isOpen}>
      <div className='modal-header'>
        <div className='modal-title'>Select Interview Call Time</div>
        <Close onClick={closeModal} />
      </div>
      <ModalBody>
        <OrientationList selecting updateOrientation={updateOrientation} />
      </ModalBody>
    </OrientationModal>
  )
}

export default connect(null, { updateWorkerProspectOrientation })(SelectOrientationModal);



// WEBPACK FOOTER //
// ./src/components/app/prospectsList/SelectOrientationModal/index.js